"use strict";
/**
 *
 * Grow
 *
 * https://github.com/mui-org/material-ui/blob/b18a78e8cdad5894e96e65d6451545e075ed9d15/packages/material-ui/src/Grow/Grow.js
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const utils_1 = require("../utils");
const transition_1 = require("../styles/transition");
const styles_1 = require("../styles");
function getScale(value) {
    return `scale(${value}, ${Math.pow(value, 2)})`;
}
const styles = {
    entering: {
        opacity: 1,
        transform: getScale(1),
    },
    entered: {
        opacity: 1,
        transform: 'none',
    },
};
exports.Grow = react_1.default.forwardRef(function Grow(props, ref) {
    const { children, in: inProp, onEnter, onExit, style, timeout = 'auto' } = props, other = __rest(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
    const timer = react_1.default.useRef();
    const autoTimeout = react_1.default.useRef();
    const handleRef = utils_1.useForkRef(children.ref, ref);
    const theme = styles_1.useTheme();
    const handleEnter = (node, isAppearing) => {
        transition_1.reflow(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay } = transition_1.getTransitionProps({ style, timeout: timeout === 'auto' ? undefined : timeout }, {
            mode: 'enter',
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transition.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        }
        else {
            duration = transitionDuration;
        }
        node.style.transition = [
            theme.transition.create('opacity', {
                duration,
                delay,
            }),
            theme.transition.create('transform', {
                duration: duration * 0.666,
                delay,
            }),
        ].join(',');
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    };
    const handleExit = (node) => {
        const { duration: transitionDuration, delay } = transition_1.getTransitionProps({ style, timeout: timeout === 'auto' ? undefined : timeout }, {
            mode: 'exit',
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transition.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        }
        else {
            duration = transitionDuration;
        }
        node.style.transition = [
            theme.transition.create('opacity', {
                duration,
                delay,
            }),
            theme.transition.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333,
            }),
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = getScale(0.75);
        if (onExit) {
            onExit(node);
        }
    };
    const addEndListener = (_0, next) => {
        if (timeout === 'auto') {
            timer.current = setTimeout(next, autoTimeout.current || 0);
        }
    };
    react_1.default.useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);
    return (react_1.default.createElement(react_transition_group_1.Transition, Object.assign({ appear: true, in: inProp, onEnter: handleEnter, onExit: handleExit, addEndListener: addEndListener, timeout: timeout === 'auto' ? null : timeout }, other), (state, childProps) => {
        return react_1.default.cloneElement(children, Object.assign({ style: Object.assign(Object.assign(Object.assign({ opacity: 0, transform: getScale(0.75), visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, styles[state]), style), children.props.style), ref: handleRef }, childProps));
    }));
});
if (process.env.NODE_ENV !== 'production') {
    exports.Grow.displayName = 'Grow';
}
